export const MULTICHECKBOX_FILTER = 'MULTICHECKBOX_FILTER'
export const TEXT_FILTER = 'TEXT_FILTER'

// TODO - clear up commented code, but wait until design is finalised
// ==================== MULTICHECKBOX_FILTER SETUP ==================== //

// default format for filter-able props of issues should be { [filterName]: { id: ..., name: ... } }
// this function, when called on filterName, maps issues to an obj with distinct { id: name } pairings
// const getFilterOptions = (filterName, noFilterNameText) => (issues = []) => {
//   const obj = {}
//   issues.forEach(issue => {
//     const { [filterName]: { id, name } = {} } = issue
//     if (!id) {
//       Object.assign(obj, { '': `No ${noFilterNameText || filterName}` })
//     } else if (!obj[id]) {
//       Object.assign(obj, { [id]: name })
//     }
//   })
//   return obj
// }

// const applyFilter = (filterName) => (selected = []) =>
//   (issue) => selected.includes(((issue || {})[filterName] || {}).id || '')

// ==================== format for modelCategory ==================== //
const BASE_MODEL = '0',
  PROJECT_MODEL = '1'
// MODEL_TRANSFER = '2',
// OTHERS = '3',
// FLOOD_RISK_ASSESSMENT = '4',
// STATUTORY_PLAN = '5',
// SCENARIO_ASSESSMENT = '6',
// OPTIONEERING_ASSESSMENT = '7'

const portalGroupNames = {
  [BASE_MODEL]: 'Base Model',
  [PROJECT_MODEL]: 'Project Model',
  // [STATUTORY_PLAN]: 'Project - Statutory Plan',
  // [SCENARIO_ASSESSMENT]: 'Project - Scenario Assessment',
  // [OPTIONEERING_ASSESSMENT]: 'Project - Optioneering Assessment',
  // [FLOOD_RISK_ASSESSMENT]: 'Project - Flood Risk Assessment',
  // [MODEL_TRANSFER]: 'Model Transfer',
  // [OTHERS]: 'Others',
}

const mapModelCategoryToPortalGroups = (modelCategory) => {
  switch (modelCategory) {
    case '10000': return BASE_MODEL
    case '10009': return PROJECT_MODEL
    default: return ''
  }
  // switch (modelCategory) {
  //   case '39': // "Initiate a new base model or update an existing base model"
  //     return BASE_MODEL
  //   case '42': //"Suggest a new base model enhancement"
  //     return BASE_MODEL
  //   case '43': //"Report an issue with a base model"
  //     return BASE_MODEL
  //   case '44': //"Request for statutory plan mapping project"
  //     // return STATUTORY_PLAN
  //     return PROJECT_MODEL
  //   case '45': //"Request for a scenario assessment project"
  //     // return SCENARIO_ASSESSMENT
  //     return PROJECT_MODEL
  //   case '46': //"Request for an optioneering assessment project"
  //     // return OPTIONEERING_ASSESSMENT
  //     return PROJECT_MODEL
  //   // case '58': //"Transfer a stormwater model"
  //   // case '59': //"Transfer a wastewater model"
  //   // case '60': //"Transfer a water supply model"
  //   //   return MODEL_TRANSFER
  //   // case '55': //"Request help with anything else"
  //   // case '56': //"Inbound Email"
  //   // case '73': //"Suggest improvement to guidelines"
  //   // case '74': //"Request common GIS data"
  //   case '95': //"Request a flood risk assessment"
  //     // return FLOOD_RISK_ASSESSMENT
  //     return PROJECT_MODEL
  //   //   return OTHERS
  //   default: //"No request type"
  //     return ''
  // }
}

const getModelCategoryFilterOptions = (issues = []) => {
  const obj = {}
  issues.forEach(issue => {
    const { issuetype: { id } = {} } = issue
    if (!id) {
      Object.assign(obj, { '': 'No request type' })
    } else {
      const portalGroupId = mapModelCategoryToPortalGroups(id)
      if (!obj[portalGroupId]) {
        Object.assign(obj, { [portalGroupId]: portalGroupNames[portalGroupId] })
      }
    }
  })
  return obj
}

const applyModelCategoryFilter = (selected = []) =>
  (issue) => selected.includes(mapModelCategoryToPortalGroups(issue?.issuetype?.id))

// ==================== format for status ==================== //
const ARCHIVE_STATUS_ID = '10074'
const STATUS_TO_DO = '0',
  STATUS_IN_PROGRESS = '1',
  STATUS_ARCHIVE = '2',
  STATUS_DONE = '3'

const mapCatIdToStatus = (catId) =>
  catId === 2
    ? STATUS_TO_DO
    : catId === 3
      ? STATUS_DONE
      : catId === 4
        ? STATUS_IN_PROGRESS
        : null


const getStatusFilterOptions = (issues = []) => {
  const obj = {}

  issues.forEach(issue => {
    const {
      status: {
        id: statusId,
        statusCategory: { id: catId, name: catName } = {}
      } = {}
    } = issue

    if (catId) {
      if (statusId === ARCHIVE_STATUS_ID) {
        Object.assign(obj, { [STATUS_ARCHIVE]: 'Archiving' })
      } else if (catId === 3) {
        Object.assign(obj, { [STATUS_DONE]: 'Completed' })
      } else {
        const key = mapCatIdToStatus(catId)
        if (key) { Object.assign(obj, { [key]: catName }) }
      }
    }
  })

  return obj
}

const applyStatusFilter = (selected = []) =>
  (issue) => selected.some(el => {
    if (issue?.status?.id === ARCHIVE_STATUS_ID) { return el === STATUS_ARCHIVE }
    return el === mapCatIdToStatus(issue?.status?.statusCategory?.id)
  })

// ==================== TEXT_FILTER SETUP ==================== //


const applyTextFilter = (filterName) => (searchString = ['']) => {
  const words = searchString[0].split(' ')
  const regex = new RegExp('^'.concat(...words.map(w => `(?=.*${w})`), '.*$'), 'igm')
  return (issue) => ((issue || {})[filterName] || '').match(regex)
}

const applyStrictTextFilter = (filterName) => (searchString = ['']) => {
  const stringWithWildcards = searchString[0].replace('*', '.*')
  const words = stringWithWildcards.split(' ')
  const regex = new RegExp(''.concat(...words.map(w => `(?=.*(?:^|\\s)${w}(?:$|\\s))`), '.*'), 'igm')
  return (issue) => ((issue || {})[filterName] || '').match(regex)
}

export const filterConfig = {
  // scenario: {
  //   label: 'Scenario',
  //   type: TEXT_FILTER,
  //   apply: applyTextFilter('scenario'),
  // },
  modelCategory: {
    label: 'Model Category',
    type: MULTICHECKBOX_FILTER,
    apply: applyModelCategoryFilter,
    getOptions: getModelCategoryFilterOptions,
  },
  status: {
    label: 'Status',
    type: MULTICHECKBOX_FILTER,
    apply: applyStatusFilter,
    getOptions: getStatusFilterOptions,
  },
  event: {
    label: 'Event',
    type: TEXT_FILTER,
    apply: applyTextFilter('event'),
  },
  summary: {
    label: 'Summary',
    type: TEXT_FILTER,
    apply: applyTextFilter('summary'),
  },
  reference: {
    label: 'Reference',
    type: TEXT_FILTER,
    apply: applyStrictTextFilter('key'),
  },
  software: {
    label: 'Software',
    type: TEXT_FILTER,
    apply: applyTextFilter('software')
  }
  // organization: {
  //   label: 'Organization',
  //   type: MULTICHECKBOX_FILTER,
  //   apply: applyFilter('organization'),
  //   getOptions: getFilterOptions('organization'),
  // },
  // modellers: {
  //   label: 'Modellers',
  //   type: TEXT_FILTER,
  //   apply: applyTextFilter('modellers'),
  // },
}